
import Vue from "vue";
import DocumentMetadata from "@/features/Documents/DocumentMetadata";
import AppError from "@/shared/components/AppError.vue";
import PlatformDocumentMetadata from "@/features/PlatformDocuments/PlatformDocumentMetadata";

// Only used for platform documents
export enum FileListDocumentType {
    Action = "Action",
    Note = "Note",
    SupplierEvent = "Supplier event",
}

export default Vue.extend({
    name: "FileList",
    components: {
        AppError,
    },
    data: () => ({
        errorMessage: "",
        showError: false,
    }),
    props: {
        documentMetadatas: {
            type: Array,
            default: [] as DocumentMetadata[] | PlatformDocumentMetadata[],
            required: true,
        },
        // Whether documents downloaded from this component should come from the CQMS Platform (true) or Compliance (false)
        forPlatform: {
            type: Boolean,
            default: false,
        },
        // Platform documents only: ID of the object these documents are attached to
        documentParentID: {
            type: String,
            default: null,
        },
        // Platform documents only: A FileListDocumentType value
        documentType: {
            type: String,
            default: null,
        },
        compact: {
            type: Boolean,
            default: false,
        },
        hr: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        async downloadDocument(doc: DocumentMetadata | PlatformDocumentMetadata): Promise<void> {
            try {
                if (this.forPlatform) {
                    const platformDocMeta = doc as PlatformDocumentMetadata;

                    switch (this.documentType) {
                        case FileListDocumentType.Action:
                            await this.$actionService.getDocumentByArchiveID(this.documentParentID, platformDocMeta.documentArchiveID!, platformDocMeta.name);
                            break;
                        case FileListDocumentType.SupplierEvent:
                            await this.$supplierEventService.getSupplierEventDocument(this.documentParentID, platformDocMeta.documentArchiveID!, platformDocMeta.name);
                            break;
                        case FileListDocumentType.Note:
                            await this.$noteService.getDocumentByArchiveID(this.documentParentID, platformDocMeta.documentArchiveID!, platformDocMeta.name);
                            break;
                        default:
                            console.error("Unknown document type on FileList");
                            break;
                    }
                } else {
                    const docMeta = doc as DocumentMetadata;

                    await this.$documentDownloadService.downloadDocument(docMeta.id, docMeta.name);
                }
            } catch (err) {
                this.errorMessage = `Failed to download document: ${doc.name}`;
                this.showError = true;
            }
        },
    },
});
